import { api } from "./Api";
import { toast } from "react-toastify";

export const addSpeakerToEvent = async (eventId: string, speakerId: string) => {
  try {
    return toast.promise(
      api.post(
        `/admin/event/${eventId}/speaker/${speakerId}/add`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      ),
      {
        success: "Palestrante vinculado ao evento!",
        error: "Erro ao vincular palestrante ao evento.",
      }
    );
  } catch (erro) {
    return false;
  }
};

export const removeSpeakerFromEvent = async (
  eventId: string,
  speakerId: string
) => {
  try {
    return toast.promise(
      api.delete(`/admin/event/${eventId}/speaker/${speakerId}/remove`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
      {
        success: "Palestrante removido do evento!",
        error: "Erro ao remover palestrante do evento.",
      }
    );
  } catch (erro) {
    return false;
  }
};
